// Scales the bar border radius so it stays proportional to how wide each bar
// actually renders. `baseRadius` is the radius that looks right at
// `referenceLength` bars; with more bars the radius shrinks, with fewer it
// grows (capped at `maxRadius`).
export function computeBarRadius ({ dataLength, baseRadius = 5, maxRadius = 40, referenceLength = 30 }) {
    if (!dataLength) return baseRadius;
    return Math.min(maxRadius, Math.max(1, Math.round(baseRadius * (referenceLength / dataLength))));
}

// Returns an ApexCharts `zoomed` event handler that scales the bar border
// radius proportionally as the user zooms in, so wider bars keep looking
// rounded instead of flat. Reusable across bar charts.
export function createBarRadiusZoomHandler (totalRange, { baseRadius = 5, maxRadius = 40 } = {}) {
    return (chartContext, { xaxis }) => {
        const visibleRange = xaxis.max - xaxis.min;
        if (!visibleRange || !totalRange) return;
        const radius = Math.min(maxRadius, Math.round(baseRadius * (totalRange / visibleRange)));
        chartContext.updateOptions(
            { plotOptions: { bar: { borderRadius: radius } } },
            false,
            false,
        );
    };
}

export const Options = {
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '55%',
                borderRadius: 5,
                borderRadiusApplication: 'end',
            },
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            curve: 'smooth',
        },
        legend: {
            show: false,
        },
        chart: {
            id: 'NewSubscriptions',
            stacked: false,
            toolbar: {
                show: true,
            },
        },
        tooltip: {
          shared: false,
          y: {
            title: {
              formatter: () => 'New subs.',
            },
          },
        },
        colors: ['#0078FF', '#fff'],
        fill: {
            type: 'gradient',
            gradient: {
                shade: 'light',
                type: 'vertical',
                gradientToColors: ['#000082'],
                shadeIntensity: 1,
                inverseColors: false,
                opacityFrom: 1,
                opacityTo: 1,
                stops: [0, 100],
            },
        },
        options: {
            plotOptions: {
                bar: {
                    horizontal: true,
                    dataLabels: {
                        position: 'top',
                    },
                },
            },
            dataLabels: {
                enabled: true,
                offsetX: -6,
                style: {
                    fontSize: '12px',
                    colors: ['#fff'],
                },
            },
            stroke: {
                show: true,
                width: 1,
                colors: ['#fff'],
            },

            xaxis: {
                categories: [2013, 2014, 2015, 2016, 2017, 2018, 2019],
            },
            // colors: ['rgba(206, 230, 180, 1)', 'rgba(206, 230, 180, 0.3'],
        },
        states: {
          normal: {
              filter: {
                  type: 'none',
                  value: 0,
              },
          },
          hover: {
              filter: {
                  type: 'lighten',
                  value: -0.3,
              },
          },
          active: {
              allowMultipleDataPointsSelection: false,
              filter: {
                  type: 'lighten',
                  value: -0.4,
              },
          },
      },
};
